// TODO: CONVERT TO TYPESCRIPT
import DarkArticleIcon from 'images/post_icons/dark/article.svg'
import DarkCaseStudyIcon from 'images/post_icons/dark/case_study.svg'
import DarkCustomerTestimonialIcon from 'images/post_icons/dark/customer_testimonial.svg'
import DarkDownloadIcon from 'images/post_icons/dark/download.svg'
import DarkLineCardIcon from 'images/post_icons/dark/line_card.svg'
import DarkNewspaperIcon from 'images/post_icons/dark/newspaper.svg'
import DarkPodcastIcon from 'images/post_icons/dark/podcast.svg'
import DarkPriceListIcon from 'images/post_icons/dark/price_list.svg'
import DarkWebinarIcon from 'images/post_icons/dark/webinar.svg'
import DarkWhitePaperIcon from 'images/post_icons/dark/white_paper.svg'
import LightArticleIcon from 'images/post_icons/light/article.svg'
import LightCaseStudyIcon from 'images/post_icons/light/case_study.svg'
import LightCustomerTestimonialIcon from 'images/post_icons/light/customer_testimonial.svg'
import LightDownloadIcon from 'images/post_icons/light/download.svg'
import LightLineCardIcon from 'images/post_icons/light/line_card.svg'
import LightNewspaperIcon from 'images/post_icons/light/newspaper.svg'
import LightPodcastIcon from 'images/post_icons/light/podcast.svg'
import LightPriceListIcon from 'images/post_icons/light/price_list.svg'
import LightWhitePaperIcon from 'images/post_icons/light/white_paper.svg'

import Email from 'images/suppliers/review_collection_toolkit/email.png'
import QrCode from 'images/suppliers/review_collection_toolkit/qr_code.png'
import Collection from 'images/suppliers/review_collection_toolkit/collection.png'
import VideoThumbnail from 'images/suppliers/review_collection_toolkit/video_thumbnail.png'
import Testimonial from 'images/suppliers/review_collection_toolkit/testimonial.png'
import Stats from 'images/suppliers/review_collection_toolkit/stats.png'
import CaseStudy from 'images/suppliers/review_collection_toolkit/case_study.png'
import ReplyToReviewsImportance from 'images/suppliers/review_collection_toolkit/reply_to_reviews.png'
import ReviewGathering from 'images/suppliers/review_collection_toolkit/review_gathering.webp'

export const POST_ICON_MAPPING = {
  light: {
    article: LightArticleIcon,
    case_study: LightCaseStudyIcon,
    customer_testimonial: LightCustomerTestimonialIcon,
    download: LightDownloadIcon,
    line_card: LightLineCardIcon,
    newspaper: LightNewspaperIcon,
    podcast: LightPodcastIcon,
    price_list: LightPriceListIcon,
    white_paper: LightWhitePaperIcon
  },
  dark: {
    article: DarkArticleIcon,
    case_study: DarkCaseStudyIcon,
    customer_testimonial: DarkCustomerTestimonialIcon,
    download: DarkDownloadIcon,
    line_card: DarkLineCardIcon,
    newspaper: DarkNewspaperIcon,
    podcast: DarkPodcastIcon,
    price_list: DarkPriceListIcon,
    webinar: DarkWebinarIcon,
    white_paper: DarkWhitePaperIcon
  }
}

export const BG_IMAGE_MAPPING = {
  email: Email,
  qrCode: QrCode,
  collection: Collection,
  videoThumbnail: VideoThumbnail,
  testimonial: Testimonial,
  stats: Stats,
  caseStudy: CaseStudy,
  replyToReviewsImportance: ReplyToReviewsImportance,
  reviewGathering: ReviewGathering
}
